import Alert from './Notification/Alert';
import Confirm from './Notification/Confirm';
import Layer from './Notification/Layer';
import Toast from './Notification/Toast';

/**
 * @alias Modal
 * @category modal
 * @example
 * if (window.ncui && window.ncui.modal) {
 *    const ncuiAlert = new window.ncui.modal.uiAlert();
 *    const ncuiConfirm = new window.ncui.modal.uiConfirm();
 *    const ncuiLayer = new window.ncui.modal.uiLayer();
 *    const ncuiToast = new window.ncui.modal.uiToast();
 * }
 */
export default class Index {
    static uiAlert = Alert;
    static uiConfirm = Confirm;
    static uiLayer = Layer;
    static uiToast = Toast;
}
